<template>
  <div>
    
   <section id="chatroom_list"  v-cloak class="container chatroom_list">

        <section class="main_body">
            <div class="search_store">
                <div class="search-warp">
                     <input class="form-control" id="" value="" type="text" placeholder="搜尋" v-model='search_keyword'>
                    <a class="btn-search" >
                      <i class="fa fa-search"><font-awesome-icon :icon="['fa','search']" /></i>
                    </a>
                </div>
            </div>

            
            <div class="contacted_list">
                <div class="list_card"  v-for = "(item) in chatroom_list" v-bind:key="item.index" @click="handler_click(item)">
                    <div class="block_1 head_img">
                        <span>{{(item.user_name).substring(0,2)}}</span>
                    </div>
                    <div class="block_2">
                        <p class="store_name">{{item.user_name}}</p>
                        <p class="content">{{item.msg_content}}</p>
                    </div>
                    <div class="block_3">
                        <p class="contact_time">{{(item.last_contact_time)| handle_time}}</p>
                        <p class="unread_msg_num" v-if="item.unreads>0">{{item.unreads}}</p>
                    </div>
                </div>
            </div>
        </section>
    </section>
    
    

  </div>
</template>

<script>

import $ from 'jquery';
import axios from 'axios';

export default {
  name: 'ChatList',
  components:{
    
  },
  props: {
    // 'store_id':Number
  },
  data: function () {
    return {
      chatroom_list:[],
      search_keyword:'',
      //get_new_msg_Interval:{},
      //上一個settimeout的實例參照
      REFRESH_PREV_RUN:null,
      //當下刷新頻率秒數
      REFRESH_NEW_MSG_SECONDS:10,//10秒刷新一次
      //上一次api讀取到最新的訊息時間(判斷有無需要refresh)
      REFRESH_LAST_MSG_TIME:0,
      //連續無新訊息次數計數,用於動態延長等待時間減少後端loading
      REFRESH_NO_CHANGE_COUNT:0
    }
  },
  filters:{
      handle_time : function(value) {
          // value = "2019-12-11 17:04:24";
          
          var amount = new Date().getTime()-new Date(value.substr(0,10)).getTime(),days;
              amount = Math.floor(amount / 1000),//去掉milliseconds
              days = Math.floor(amount / 86400);//

          //‘-' 換成 '/'
          value = value.replace(/-/g,'/');

          //今天
          // -> 05:11
          if(days == 0){
              value = value.substring(11,16)
          }
          //非今天但在一年內
          // -> 06/11
          else if(days >= 1 & days < 366){
              value = value.substring(5,10)
          }
          //一年前
          // -> 2019/06/11
          else{
              value = value.substring(0,11)
          }

          return value;
      }
  },
  watch:{
    //列表搜尋
    search_keyword:function(){
        var _list_card =  document.querySelectorAll('.list_card'),
            that = this,
            handle_word =  (that.search_keyword).trim();
        
        _list_card.forEach(function(val){
            if(that.search_keyword.length == 0 | handle_word == ''){
                val.style.display = 'flex';
            }else{
                val.style.display = 'none';
            }
        });
        _list_card.forEach(function(val){
            val.childNodes.forEach(function(val1) {
                if ((val1.innerText && handle_word != '')){
                    if((val1.innerText).indexOf(handle_word) > -1){
                        val.style.display = 'flex';
                    }
                }
            });
        });
    }
  },
  created() {
  },
  mounted () {
    this.init();
  },
  computed: {},
  methods: {
    init(){
        //手機版時,聊天列表顯示下面的快速功能選單(固定恢復顯示),聊天室內頁才藏起來(固定藏起來)
        this.$bus.hideMobileNavi = false;
        this.refresh(true);
        this.handle_leave_temporarily();
        //原本的寫法其實也ok,只是不能動態調整等待時間,也不能手動停掉排程再重啟排程,改成和ChatroomView類似架構
        /*
        let that = this;
        that.get_new_msg_Interval= setInterval(function () {
            console.log(that.REFRESH_NEW_MSG_SECONDS,'秒刷新一次')
            that.getChatroomList ();
        },that.REFRESH_NEW_MSG_SECONDS * 1000);*/
      
      document.querySelector('body').style.overflowY = 'hidden';
      var list_container = document.querySelector('.search_store'),
          old_scroll=0,
          visible_h,
          search_store_h,
          search_store_w;

     resize(); 
      window.onresize = function(){
          resize(); 
      }
      //只監聽main_body！！
      document.querySelector('.main_body').addEventListener("scroll", function(e){
          //向下捲
          if(this.scrollTop  > old_scroll){
              list_container.classList.add('opacity0');
              if(!list_container.classList.contains('test_fixed')){
                document.querySelector('.contacted_list').style.marginTop = '';
              }
          }
          //到頂
          else if(this.scrollTop == 0){
              list_container.classList.remove('opacity0');
              list_container.classList.remove('test_fixed');
              document.querySelector('.contacted_list').style.marginTop = '';
          }
          //向上捲
          else{
              list_container.classList.add('test_fixed');
              list_container.style.width = search_store_w +'px';
              document.querySelector('.contacted_list').style.marginTop = (search_store_h) +'px';
          }
          old_scroll = this.scrollTop;
      });
       function resize(){
        search_store_h = list_container.offsetHeight + 21;
             
        setTimeout(function(){
                $('.main_body').height 
                (
                    $(window).height()
                    -$('.navbar')[0].offsetHeight
                    -($('.bottom-navigator')[0]?$('.bottom-navigator')[0].offsetHeight:0)
                    -$('.top_header')[0].offsetHeight
                );
        },500);
      }
    },
    refresh(restart = false) {
        let that = this
        // call refresh(true) to restart refresh, clearTimeout(that.REFRESH_PREV_RUN) to stop refresh
        if (restart === true) {
            console.log('init list');
            //得要release上一個執行排程,否則那一條不會斷,會變成兩倍執行次數
            //若用變數判斷,停用把某個變數設為停用,判斷沒停用才繼續run...重新啟用立即恢復該變數為啟用,有機會在上一個round未結束時再產生新thread喔
            //所以還是要把一次性的timeout給接起來手動release掉
            //目前測試hot update時仍會有多線程停不掉的bug,但沒有跑一半改code存檔時的log是正確的
            if (that.REFRESH_PREV_RUN !== null){
                clearTimeout(that.REFRESH_PREV_RUN);
            }
            //初始值
            that.REFRESH_NO_CHANGE_COUNT = 0;
            that.REFRESH_NEW_MSG_SECONDS = 10;
        }
        // 等待很久無新訊息延長pull時間(一分鐘後改30秒一次 10分鐘後改5分鐘一次)
        if (that.REFRESH_NO_CHANGE_COUNT >= 6 && that.REFRESH_NO_CHANGE_COUNT <= 18) {
            that.REFRESH_NEW_MSG_SECONDS = 30;
        }
        else if (that.REFRESH_NO_CHANGE_COUNT >= 19) {
            that.REFRESH_NEW_MSG_SECONDS = 300;
        }
        that.getChatroomList();
            that.REFRESH_PREV_RUN = setTimeout(() => {
                //console.log(that.REFRESH_NO_CHANGE_COUNT,' list ... ',that.REFRESH_NEW_MSG_SECONDS,'秒刷新一次')
                //recursive自己
                that.refresh();
            },that.REFRESH_NEW_MSG_SECONDS * 1000);
        //}
    },
    handle_leave_temporarily:function(){
        let that = this
        //畫面離開時(縮小、切換分頁)觸發
        ifvisible.on("blur", function(){
            clearTimeout(that.REFRESH_PREV_RUN)
            console.log('你離開了聊天列表,記錄時間:',new Date());
        });

        //畫面回來時(縮小、切換分頁)觸發
        ifvisible.on("focus", function(){
            console.log('你回來了聊天列表,記錄時間:',new Date());
            //回畫面，現在時間 － 閒置時紀錄的時間
            that.refresh(true);
            
        });
    },
    getChatroomList () {
        //這個抓圖的api應該沒實際使用到
        /*const AuthStr = 'Bearer '.concat('TOKEN');
        axios.get(
            'https://media.giphy.com/media/C6JQPEUsZUyVq/giphy.gif',
            { params: { ID: 123 } },
            { headers: { Authorization: AuthStr } }
            )
            .then(response => {
                console.log(response)
            })
            .catch(error => {
                console.log(error)
            })
        */


      let Param = {
        'module':'store_chat',
        'method':'getStoreChatUsers',
        'load_all':0
      }
      this.$bus.apiCall(Param, function (data, vm) {
        if (data.ok === 0) {
            vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
            return
          }
        
        //   for(var i=1 ; i <= 10 ; i++){
            //   data.data[0].unreads = 9999;
        //     vm.chatroom_list.push(data.data[0]);
        //   }
          if (data.data.length > 0) {
              if (vm.REFRESH_LAST_MSG_TIME != data.data[0].last_contact_time) {
                //有更新的資料再刷新列表數據就好
                vm.chatroom_list = data.data;
                vm.REFRESH_NO_CHANGE_COUNT = 0;
                vm.REFRESH_LAST_MSG_TIME = data.data[0].last_contact_time;
              }
              else {
                  vm.REFRESH_NO_CHANGE_COUNT++;
              }
          }
          else {
              //如果因故(如查詢條件)造成列表變空的,把REFRESH_LAST_MSG_TIME清空,如果下一次的最後訊息時間不一樣就重置等待間隔的計數
              vm.REFRESH_LAST_MSG_TIME = 0;
          }
          //處理數字過長,小紅圈樣式
          vm.$nextTick(function () {
            (document.querySelectorAll('.unread_msg_num')).forEach(function(element){
                if(element.textContent.length>2){
                    element.style.width = 'auto';
                    element.style.borderRadius = '50px';
                    element.style.padding = '0 5px';
                }
            });
          });
          
      },this)
    },
    //記錄資訊、跳轉
    handler_click:function(item){
        console.log('You choose of user_info : ',item);
        //把店家資訊寫到bus
        this.$bus['user_info'] = {
            user_id  : item.user_id,
            user_name: item.user_name,
            last_contact_time : item.last_contact_time
        }
        //進聊天室要把列表監聽刷新timeout清除,不要繼續loop
        clearTimeout(this.REFRESH_PREV_RUN);
        //叫父層改component
        this.$parent.$emit('chang_view',{
          view:'ChatroomView',
          user_info: this.$bus['user_info']
        });
        
    },
  },
  beforeDestroy:function(){
    ifvisible.off('blur');
    ifvisible.off('focus');
    clearTimeout(this.REFRESH_PREV_RUN);
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  #chatroom_list{
   .main_body{
        min-width:unset;
        overflow: auto;
        // height: calc( 100vh / 1.5);
        padding-bottom: 40px;
    }
    .search_store.test_fixed{
      position: fixed;
      opacity: 1;
      right: 0;
      left: 0;
      transition: all 1s;
    }
    /*-------------聊天室清單----------*/
    .search_store {
        width: calc(65vw);
        // margin: 0 21px 0px 21px;
        margin:0 auto;
    }
    .search_store .search-warp {
        margin: 0 .75rem 0px;
        position: relative;
    }
    .search_store .search-warp .btn-search {
        position: absolute;
        top: 3px;
        left: 10px;
    }
    .search_store .search-warp .btn-search i,
    .search_store .search-warp .btn-search i {
        color: #ffe49b;
        font-size: 24px;
        line-height: 2rem;
    }
    .search_store .search-warp .form-control,
    .msg_input_container .form-control {
        margin-top: 16px;
        border-radius: 2rem;
        height: 2rem;
        min-height: 2rem;
        padding: 0 1rem;
        padding-left: 2.5rem;
        border: solid 1px #e1dede;
        font-size: 1rem;
    }

    /*與店家聊天清單*/
    .contacted_list{
        margin: 5px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.33;
        letter-spacing: normal;
    }
    .contacted_list .list_card{
        display: flex;
        border-bottom: 1px solid #e9ecef;
        padding: 15px 8px 15px 15px;
    }
    .block_1.head_img,
    .talk_block .head_img
    {
        width: 75px;
        height: 75px;
        background-color: #d9dfe2;
        border-radius: 50%;
        display: flex;
        flex: none;
        align-items: center;
        justify-content: center;
        margin-right:11px;
    }
    .block_1 span,
    .talk_block .head_img span{
        font-size: 23px;
        color: #ffffff;
    }
    .block_2{
        width: -webkit-fill-available;
        width: -moz-available;
    }
    .block_2 .store_name{
            text-align: left;
        font-size: 20px;
        color: #222222;
        margin-top: 12px;
    }
    .block_2 .content{
        text-align: left;
        font-size: 18px;
        color: #777777;
    }
    .block_3{
        text-align: -webkit-right;
        text-align: -moz-right;
        // min-width: 80px;
    }
    .block_3 .contact_time{
        font-weight: normal;
        font-size: 15px;
        color: #888888;
        margin-top: 10px;
    }
    .block_3 .unread_msg_num{
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        width: 29px;
        min-height: 29px;
        background-color: var(--main-color);
        font-size: 18px;
        color: #ffffff;
        margin-top: 5px;
    }
    @media (max-width: 320px) {
      .block_1.head_img {
          margin-top: 10px;
          flex: none;
          width: 55px;
          height: 55px;
      }

      .block_1 span {
          font-size: 20px;
      }

      .block_2 .store_name {
          font-size: 18px;
      }

      .block_2 .content {
          font-size: 15px;
      }

      .block_3 .unread_msg_num {
          font-size: 13px;
        //   width: 25px;
        //   height: 25px;
      }
    }

  }
</style>

